"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselDotMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var activeCSS = function activeCSS(props) {
  var isActive = props.isActive;
  if (!isActive) {
    return '';
  }
  return (0, _styledToken.default)('PhotoCarousel.dot.size.lg', function (size) {
    return (0, _styledComponents.css)(["width:", "px;height:", "px;opacity:1;"], size, size);
  })(props);
};
var isContinuationCSS = function isContinuationCSS(props) {
  var isContinuation = props.isContinuation;
  if (!isContinuation) {
    return '';
  }
  return (0, _styledToken.default)('PhotoCarousel.dot.size.sm', function (size) {
    return (0, _styledComponents.css)(["width:", "px;height:", "px;"], size, size);
  })(props);
};

/** @class PhotoCarouselDotMixin */
/** @method */
var PhotoCarouselDotMixin = function PhotoCarouselDotMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'PhotoCarousel.dot.backgroundColor',
    borderRadius: 'PhotoCarousel.dot.borderRadius',
    boxShadow: 'PhotoCarousel.dot.boxShadow',
    dotSize: 'PhotoCarousel.dot.size.md',
    opacity: 'PhotoCarousel.dot.opacity',
    marginX: 'PhotoCarousel.dot.marginX',
    marginY: 'PhotoCarousel.dot.marginY',
    transitionEasing: 'PhotoCarousel.dot.transition.easing',
    transitionDuration: 'PhotoCarousel.dot.transition.duration',
    transitionProperty: 'PhotoCarousel.dot.transition.property',
    transitionDelay: 'PhotoCarousel.dot.transition.delay'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      dotSize = _ref.dotSize,
      marginX = _ref.marginX,
      _ref$marginY = _ref.marginY,
      marginY = _ref$marginY === void 0 ? 0 : _ref$marginY,
      opacity = _ref.opacity,
      transitionEasing = _ref.transitionEasing,
      transitionDuration = _ref.transitionDuration,
      transitionProperty = _ref.transitionProperty,
      transitionDelay = _ref.transitionDelay;
    return (0, _styledComponents.css)(["display:inline-block;width:", "px;height:", "px;background-color:", ";border-radius:", ";box-shadow:", ";vertical-align:middle;transition:", " ", "s ", " ", "s;margin:", " ", ";opacity:", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}@media (prefers-reduced-motion:reduce){&{transition:none;}}", " ", ""], dotSize, dotSize, backgroundColor, borderRadius, boxShadow, transitionProperty, transitionDuration, transitionEasing, transitionDelay, marginY, marginX ? marginX + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props), opacity, activeCSS(props), isContinuationCSS(props));
  })(props);
};
exports.PhotoCarouselDotMixin = PhotoCarouselDotMixin;